'use strict';

angular.module('ClinicApp').directive('saveCancelButtons', function() {
  return {
    scope: {
      onSave: '&',
      onCancel: '&',
      saveText: '=',
      saveDisabled: '&',
    },
    templateUrl: '/views/directives/_save-cancel-buttons.html',
  };
});
